import * as React from 'react';

import { Tabs } from 'antd';

import {Link, NavLink, Route, Switch, Redirect, useHistory} from 'react-router-dom';

import {Form, Formik, FormikProps} from 'formik';

import loadable from '@loadable/component';

import {loadableDelay, params} from '@common/react/loadable/loadableSettings';
import {List} from '@common/typescript/objects/List';

import SimpleMap from '@app/components/UI/SimpleMap/SimpleMap';

import '@app/scss/components/findVet.scss';
import SearchField from '@app/components/Forms/SearchField/SearchField';
import CustomInput from '@app/components/UI/CustomInput/CustomInput';
import SearchFieldAuto from '@app/components/Forms/SearchField/SearchFieldAuto';
import {ListOption} from '@app/objects/SidebarProps';
import {rest} from '@app/components/Api';
import {StatesListItem} from '@app/objects/StatesListItem';
import withSeo from '@app/components/LocalCommon/HigherOrderComponents/WithSeo';
import {stateFilter} from '@app/components/LocalCommon/Utils/StateFilter';
import {transformStateList} from '@app/components/LocalCommon/Utils/transformList';

const AreasList = loadable(() =>
	loadableDelay(import(/* webpackChunkName: "AreasList" */ '@app/components/Pages/AreasList/AreasList')), params);

const { TabPane } = Tabs;

const FindVet = () => {
	const [vetQuery, setVetQuery] = React.useState('');
	const [states, setStates] = React.useState<StatesListItem[]>([]);
	const stateListOptions: ListOption[] = [];
	const [currentState, setCurrentState] = React.useState<string>('');
	const [redirect, setRedirect] = React.useState<string>('');
	const [zipCodeQuery, setZipCodeQuery] = React.useState('');

	React.useEffect(() => {
		rest.get<List<StatesListItem>>('v1/states/')
			.then(res => setStates(res.list));
	}, []);

	transformStateList(states, stateListOptions);

	return  (
		<div className="find-vet-page">

			<div className="find-vet-page__inner">
				<h1 className="find-vet-page__title">Find a veterinarian near you</h1>
				<p className="find-vet-page__description">
					Lap of Love veterinarians help families all across the United States. <br/>
					Search by location or call us now
					at <a href="tel:8559335683">(855)933-5683</a>
				</p>

				<div className="card-container switcher">
					<Tabs type="card">
						<TabPane tab="Location" key="1">
							<SearchField
								placeholder="Enter your 5-digit ZIP code"
								iconLocation={true}
								widthBorder={'2'}
								searchBody={'/find-a-vet/search'}
								setSearch={setZipCodeQuery}
							/>
						</TabPane>
						{/* <TabPane tab="Veterinarian" key="2">
							<Formik
								onSubmit={(values) => {
									setVetQuery(`?query=${values.firstName} ${values.lastName}`);
								}}

								initialValues={{
									firstName: '',
									lastName: ''
								}}

								render={(formikBag: FormikProps<any>) => {
									return (
										vetQuery ?
											<Redirect to ={{
												pathname: '/find-a-vet/search',
												search: vetQuery,
												state: {type: 'veterinarian'}
											}}/> :
										<Form
											className="find-vet-page__form"
										>
											<div className="vet-search-field">
												<CustomInput formikBag={formikBag} name="firstName" placeholder="First Name" />
												<span>or</span>
												<CustomInput formikBag={formikBag} name="lastName" placeholder="Last Name" />
											</div>
											<p>You can search by first and/or last name.</p>

												<button
													type={'submit'}
													className="btn btn-primary btn-md"
												>
													Search
												</button>

										</Form>
									);
								}}
							/>
						</TabPane> */}
						<TabPane tab="State" key="3">
							<Formik
								onSubmit={(values) => {
									console.log(values);
								}}
								initialValues={{state: ''}}

								render={(formikBag) => {
									return (
										<Form
											className="find-vet-page__form-state"
										>
											<SearchFieldAuto
												name="state"
												placeholder= "Select a state"
												listOptions={stateListOptions}
												formikBag={formikBag}
												onSelect = {(value, option) => {
													formikBag.setFieldValue('state', value);
													setCurrentState(`query=${value}`);
												}}
												onChange={(value) => {
													formikBag.setFieldValue('state', value);

												}}
												searchButton={false}
												customFilter={stateFilter}
											/>
											<NavLink
												to={{
													pathname: '/find-a-vet/search',
													search: currentState,
													state: {type: 'area'}
												}}
											>
												<button type={'submit'} className="btn btn-primary btn-md" >
													Search
												</button>
											</NavLink>
										</Form>
									);
								}}
							/>
							<SimpleMap
								states={states}
								getTooltip={state => `${state.veterinarians} local vets`}
								getFillColor={state => state.veterinarians > 0 ? '#c4bacf' : '#e1dce6'}
								onClick={(state) => { setRedirect(`/find-a-vet/search?query=${state.name}`); }}
							/>
							{ redirect && <Redirect to={redirect} /> }
						</TabPane>
					</Tabs>
				</div>
			</div>
		</div>
	);
};

export default withSeo(FindVet, state => state.findAVetPage, 'findAVetPage', 'find-a-vet');